import { render, staticRenderFns } from "./UpdatePartyInfo.vue?vue&type=template&id=36a457e4"
import script from "./UpdatePartyInfo.vue?vue&type=script&lang=js"
export * from "./UpdatePartyInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdatePartyInfo.vue?vue&type=style&index=0&id=36a457e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports